import React, { useRef, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import APIError from 'components/Common/APIError';
import Loading from 'components/Common/Loading';
import NoData from 'components/Common/NoData';

const SynchronizedCharts = ({ dataset, isLoading, isError, errorMsg, showMarker=false }) => {
  const chartRefs = useRef([]);
  
  const syncTooltip = (e) => {
    chartRefs.current.forEach((chart) => {
      if (chart && chart.chart) {
        const point = chart.chart.series[0].searchPoint(e, true);
        if (point) {
          point.highlight(e);
        }
      }
    });
  };

  useEffect(() => {
    const container = document.getElementById('sync-container');
    container.addEventListener('mousemove', syncTooltip);
    container.addEventListener('mouseLeave', syncTooltip);
    return () => {
      container.removeEventListener('mousemove', syncTooltip);
      container.removeEventListener('mouseLeave', syncTooltip);
    };
  }, []);

  if (!Highcharts.Point.prototype.highlight) {
    Highcharts.Point.prototype.highlight = function (event) {
      this.onMouseOver();
      this.series.chart.tooltip.refresh(this);
      this.series.chart.xAxis[0].drawCrosshair(event, this);
    };
  }

  const getChartOptions = (data) => {
   return({
    chart: {
      marginLeft: 40,
      spacingTop: 20,
      spacingRight: 30,
      spacingBottom: 20,
      height:220,
    },
    height: 90,
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false,
    },
    title: {
      text: data.title,
      align: 'left',
      style: {
        fontSize: '16px',
      }    
    },
    xAxis: {
      type: 'datetime',
      crosshair: true,
      labels: {
        formatter: function () {
          return Highcharts.dateFormat('%H:%M:%S', this.value);
        },
        fontSize: '10px',    
      },
    },
    yAxis: {
      title: {
          text: null
      }
    },
    tooltip: {
      fixed: true,
      pointFormat: '{point.y}',
      backgroundColor: 'none',
      shadow: false,
      headerFormat: '',
      style: {
          fontSize: '22px',
          fontWeight: 600,
      },
      valueSuffix: ' ' + data.unit,
      valueDecimals: 2, 
      positioner: function (labelWidth, labelHeight) {
        const chart = this.chart;
        const x = chart.plotLeft + chart.plotWidth - labelWidth - 10;
        const y = chart.plotTop -50;
        return { x, y };
      },
    },
    series: [
      {
        data: data.data,
        name: data.name,
        type: data.type,
        color: data.color,
        fillOpacity: 0.3,
        marker: {
          enabled: showMarker,
        },
      },
    ],
   }
)};

  return (
    <div id="sync-container">
      {isLoading && <Loading/>}
      {!isError ?
          dataset?.map((ds, i) => 
          ds?.data?.length ?
            <HighchartsReact
              key={i}
              highcharts={Highcharts}
              options={getChartOptions(ds)}
              ref={(el) => (chartRefs.current[i] = el)}
            />
          :
            <NoData key={i}/>
          )
      :
        <APIError message={errorMsg}/>
      }
    </div>
  );
};

export default SynchronizedCharts;
